<template>
  <div class="w-full flex gap-2" vs-align="center" :class="!!widthClass ? widthClass : 'xl:w-auto'">
    <div v-if="!!label" class="title" :class="size">{{ $t(label) }}</div>
    <div class="flex-1">
      <field-selector v-model="selectData" />
    </div>
  </div>
</template>

<script>
import FieldSelector from "@/components/selector/FieldSelector";

export default {
  name: "SearchNavItemFieldSelect",
  components: { FieldSelector },
  props: {
    label: {
      type: String,
      default: "",
    },
    value: Number | null,
    size: {
      type: String,
      default: "normal",
    },
    widthClass: String,
    name: {
      type: String,
      default: "fieldId",
    }
  },
  computed: {
    getSearchType () {
      const query = this.$route.query;
      if (query[this.name]) {
        try {
          return query[this.name]
        } catch (e) {}
      }
      return this.selectData
    },
  },
  watch: {
    value: {
      handler(value) {
        this.selectData = value;
      },
    },
    selectData: {
      immediate: true,
      deep: true,
      handler(value) {
        this.selectData = value;
        this.change(value);
      },
    },
  },
  data() {
    return {
      selectData: this.value,
    };
  },
  created() {
    this.selectData = this.getSearchType
    this.change(this.selectData);
  },
  methods: {
    change(data) {
      this.$emit("input", data);
      this.$emit("change", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {

  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;

  &.small {
    width: auto !important;
  }
}

@media (max-width: 1200px) {
  .title {
    width: 80px !important;
  }
}
</style>
